document.addEventListener('DOMContentLoaded', function() {
  // Select all spans inside the '.list-menu' class
  const collectionLinks = document.querySelectorAll('.list-menu span');

  // Iterate over each span
  collectionLinks.forEach(span => {
    // Add a click event listener to the span
    span.addEventListener('click', function() {
      // Get the aria-label value of the span
      const ariaLabel = span.getAttribute('aria-label');
      
      // Define links for each aria-label
      const links = {
        'ATV': '/collections/atv',
        'Moto': '/collections/moto',
        'Side by side': '/collections/side-by-side',
        'Jet Ski': '/collections/jet-ski',
        'Cars': '/collections/cars',
        'Boats': '/collections/boats',
        'Digital files': '/collections/templates',
      };

      // Redirect to the corresponding link if it exists
      if (ariaLabel && links[ariaLabel]) {
        window.location.href = links[ariaLabel];
      }
    });

    // Optionally, add a cursor pointer to indicate link behavior
    span.style.cursor = 'pointer';
  });
});

///////////////////
//////////////////
//////////////////

// Angle 3D product customizations
window.addEventListener("Angle3DCustomizerReady", function() {

  let currentProductLabelsData = null;

  function normalizeAngle3dLabelContexts(showInValue) {
    if (Array.isArray(showInValue)) {
      return showInValue
        .map((value) => String(value).trim().toLowerCase())
        .filter(Boolean);
    }

    return String(showInValue || '')
      .split(',')
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean);
  }

  function getCurrentProductLabelsData() {
    if (currentProductLabelsData !== null) {
      return currentProductLabelsData;
    }

    const labelsDataScript = document.querySelector('[id^="ProductLabelsData-"]');
    if (!labelsDataScript || !labelsDataScript.textContent.trim()) {
      currentProductLabelsData = false;
      return null;
    }

    try {
      const parsedData = JSON.parse(labelsDataScript.textContent);
      currentProductLabelsData = parsedData && typeof parsedData === 'object'
        ? parsedData
        : false;
    } catch (error) {
      currentProductLabelsData = false;
    }

    return currentProductLabelsData || null;
  }

  function createAngle3dProductLabelElement(label) {
    const styleKey = String(label.style_key || '').trim().toLowerCase();
    const className = styleKey ? `product-label product-label--${styleKey}` : 'product-label product-label--default';
    const url = String(label.url || '').trim();
    const text = String(label.text || '').trim();

    const element = url ? document.createElement('a') : document.createElement('span');
    element.className = className;

    if (url) {
      element.href = url;
    }

    const textElement = document.createElement('span');
    textElement.textContent = text;
    element.appendChild(textElement);

    return element;
  }

  function syncAngle3dProductLabels() {
    const container = document.querySelector('.tda-app-section-model-viewer-container');
    if (!container) return false;

    const labelsData = getCurrentProductLabelsData();
    const existingLabels = container.querySelector('.product-labels--angle-3d-product');
    const productLabels = (labelsData?.labels || []).filter((label) => {
      const text = String(label?.text || '').trim();
      if (!text) return false;

      const contexts = normalizeAngle3dLabelContexts(label.show_in);
      return contexts.includes('product');
    });

    if (!productLabels.length) {
      if (existingLabels) {
        existingLabels.remove();
      }
      return true;
    }

    const position = String(labelsData?.position || 'top').trim().toLowerCase() === 'bottom' ? 'bottom' : 'top';
    const labelsContainer = existingLabels || document.createElement('div');
    labelsContainer.className = `product-labels product-labels--${position} product-labels--angle-3d-product`;
    labelsContainer.setAttribute('aria-label', 'Product labels');
    labelsContainer.innerHTML = '';

    productLabels.slice(0, 3).forEach((label) => {
      labelsContainer.appendChild(createAngle3dProductLabelElement(label));
    });

    if (!existingLabels) {
      container.appendChild(labelsContainer);
    }

    return true;
  }

  syncAngle3dProductLabels();

  const angle3dLabelsObserver = new MutationObserver(() => {
    if (syncAngle3dProductLabels()) {
      angle3dLabelsObserver.disconnect();
    }
  });

  angle3dLabelsObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(() => {
    angle3dLabelsObserver.disconnect();
  }, 15000);

  if (window.innerWidth < 1150) {
    const productTitle = document.querySelector('.tda-customizer-product-title');
    const productVariantName = document.querySelector('.tda-customizer-variant-name');
    const container = document.querySelector('.tda-app-section-model-viewer-container');      
  
    if (productVariantName && container) {
        container.prepend(productVariantName);
    }
  
    if (productTitle && container) {
        container.prepend(productTitle);
    }
  
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  const productPrice = document.querySelector('.tda-customizer-variant-price-container');
  const priceTargetContainer = document.querySelector('.tda-customizer-customization-options-container');
  
  if (productPrice && priceTargetContainer) {
      // Move the price container
     priceTargetContainer.prepend(productPrice);
  
      // Create a span element
      const span = document.createElement('span');
      span.textContent = 'Price: '; // Add the desired text to the span
  }

  const productPriceSpan = document.querySelector('.tda-customizer-variant-price-container span');
  const quantityRow = document.querySelector('.tda-customizer-footer');
  
  if (quantityRow && priceTargetContainer) {
    priceTargetContainer.prepend(quantityRow);
  }

  // Custom URL accordion
  // Detect config from URL
  function getActiveConfigFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      const tdaState = urlParams.get('tdaState');
      if (!tdaState) return null;

      try {
          const decoded = atob(decodeURIComponent(tdaState));
          const stateObj = JSON.parse(decoded);
          const stateValues = Object.values(stateObj);

          if (stateValues.includes('p2oz1x')) return 'Custom';
          if (stateValues.includes('tj6r2d')) return 'Preset';
      } catch (e) {
          console.warn('Failed to decode tdaState:', e);
      }

      return null;
  }

  // Fallback: read selected mode from DOM
  function getSelectedModeFromDOM() {
      const $selected = $('.tda-customizer-customization-option-value-selected .tda-customizer-customization-option-value-title');
      const selectedText = $selected.text().trim().toLowerCase();
      if (selectedText === 'custom') return 'Custom';
      if (selectedText === 'presets') return 'Preset';
      return null;
  }

  // Open accordion by its title
  function openAccordionByTitle(titleText) {
      const normalizedInput = titleText.trim().toLowerCase();
      const $titleElement = $(".tda-customizer-customization-option-title").filter(function () {
          return $(this).text().trim().toLowerCase() === normalizedInput;
      });

      if ($titleElement.length) {
          const $parentOption = $titleElement.closest('.tda-customizer-customization-option');
          const $content = $parentOption.find('.tda-customizer-customization-option-value-list').first();

          if (!$content.hasClass('visible')) {
              $('.tda-customizer-customization-option-value-list').slideUp(300).removeClass('visible');
              $('.tda-customizer-customization-option-description').text('+');

              $content.slideDown(300, function () {
                  $content.addClass('visible');
              });

              $parentOption.find('.tda-customizer-customization-option-description').text('-');
          }
      } else {
          console.warn(`Accordion title not found: "${titleText}"`);
      }
  }

  // Watch for tdaState changes in DOM
  // let lastKnownState = null;
  function monitorTdaStateChanges() {
      const hadInitialTdaState = !!getActiveConfigFromURL();
      let isFirstChange = true;

      // Set initial known state
      lastKnownState = getActiveConfigFromURL();

      const observer = new MutationObserver(() => {
          const currentState = getActiveConfigFromURL();

          // If nothing changed, skip
          if (!currentState || currentState === lastKnownState) return;

          // First change after load
          if (isFirstChange) {
              isFirstChange = false;

              // Skip opening accordion if tdaState was NOT in initial URL
              if (!hadInitialTdaState) {
                  lastKnownState = currentState; // still update the known state
                  return;
              }
          }

          lastKnownState = currentState;

          if (currentState === 'Preset') {
              openAccordionByTitle('Preset Colours');
          } else if (currentState === 'Custom') {
              openAccordionByTitle('Background Colour');
          } else {
              console.log("Unknown config in tdaState");
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  }



  // SKU for 3D products  
  //   $(document).ready(function () {
  // Remove all but the first .product__sku
  const $skuBlocks = $('.template-product-3d-configurable-products .product__info-container .product__sku');
  if ($skuBlocks.length > 1) {
    $skuBlocks.not(':first').remove(); // Keep only the first one
  }

  // Select the remaining SKU
  const $sku = $('.template-product-3d-configurable-products .product__info-container .product__sku').first();

  // Extract the actual SKU text (excluding visually hidden span)
  const actualSkuText = $sku.clone().children('span.visually-hidden').remove().end().text().trim();

  // Only proceed if actual SKU is not empty
  if (actualSkuText !== '') {
    // Create wrapper div
    const $wrap = $('<div class="moved-sku-wrap"></div>');

    // Append label and SKU to wrapper
    $wrap.append('<span class="moved-sku-label">SKU: </span>');
    $wrap.append($sku);

    // Insert based on screen width
    if (window.innerWidth < 768) {
      // Mobile: insert after variant name
      $('.tda-customizer-variant-name').after($wrap);
    } else {
      // Desktop: append to the end of container
      $('.tda-product-details-top-container').append($wrap);
    }
  }
        //  });




  function toggleAccordionOnMobile() {

    if ($(window).width() < 768) {

          ////////////////
            ///////////////
           // laikinai atjungtas akardionas:
             function forceAllOpen() {
               $('.tda-customizer-customization-option-value-list').show().addClass('visible');
               $('.tda-customizer-customization-option-description').text('-');
             }

             // If you want to disable the accordion permanently while this function is called:
             forceAllOpen(); 
             const forceObserver = new MutationObserver(forceAllOpen);
             forceObserver.observe(document.body, { childList: true, subtree: true });
             return;
            ///////  laikino atjungimo pabaiga
            ////////
            ////////

        // Cache the Sticker Colours accordion by ID so we always exclude it
        const stickerSelector = '#tda-customizer-customization-option-pzm362';
              const alwaysOpenSelector = '#tda-customizer-customization-option-compoundvafujk';
        const $stickerAccordion = $(stickerSelector);
        const $stickerContent = $stickerAccordion.find('.tda-customizer-customization-option-value-list');
        const $stickerDesc = $stickerAccordion.find('.tda-customizer-customization-option-description');

        // Ensure Sticker Colours is open on load
        if ($stickerContent.length) {
            $stickerContent.slideDown(0).addClass('visible');
            $stickerDesc.text('-');
        }

        $(document).off('click').on('click', '.tda-customizer-customization-option-title, .tda-customizer-customization-option-description', function (event) {
            event.preventDefault();

            const parentOption = $(this).closest('.tda-customizer-customization-option');
            const content = parentOption.find('.tda-customizer-customization-option-value-list').first();
            const allContents = $('.tda-customizer-customization-option-value-list');
            const allDescriptions = $('.tda-customizer-customization-option-description');

            // Close all other content and reset icons EXCEPT the Sticker Colours accordion
            // Exclude sticker content by using the stickerSelector
            // const stickerContentSelector = stickerSelector + ' .tda-customizer-customization-option-value-list';
            // const stickerDescSelector = stickerSelector + ' .tda-customizer-customization-option-description';
            const protectedContentSelector = `
              ${stickerSelector} .tda-customizer-customization-option-value-list,
              ${alwaysOpenSelector} .tda-customizer-customization-option-value-list
            `;

            const protectedDescSelector = `
              ${stickerSelector} .tda-customizer-customization-option-description,
              ${alwaysOpenSelector} .tda-customizer-customization-option-description
            `;

            // allContents
            //     .not(content)
            //     .not(stickerContentSelector) // <-- do not close Sticker Colours content
            //     .slideUp(300)
            //     .removeClass('visible');

            // allDescriptions
            //     .not(stickerDescSelector) // <-- do not reset Sticker Colours description
            //     .text('+');
            allContents
            .not(content)
            .not(protectedContentSelector)
            .slideUp(300)
            .removeClass('visible');

            allDescriptions
              .not(protectedDescSelector)
              .text('+');

              // If clicked accordion is protected, do nothing
            if (parentOption.is(stickerSelector) || parentOption.is(alwaysOpenSelector)) {
              return;
            }

          // If clicked accordion is the sticker accordion, do nothing further (keep it open)
          if (parentOption.is($stickerAccordion)) {
              // Force sticker open in case something else tried to close it
              if ($stickerContent.length) {
                  $stickerContent.slideDown(0).addClass('visible');
                  $stickerDesc.text('-');
              }
              return;
          }

          // Normal toggle behavior for non-sticker accordions
          if (content.is(':visible')) {
              content.removeClass('visible');
              setTimeout(() => {
                  content.slideUp(300);
              }, 300); // Matches the CSS transition duration
              parentOption.find('.tda-customizer-customization-option-description').text('+');
          } else {
              content.slideDown(300, function () {
                  content.addClass('visible');
              });
              parentOption.find('.tda-customizer-customization-option-description').text('-');
          }

          // Re-ensure Sticker Colours remains open (in case other code closed it)
          if ($stickerContent.length) {
            $stickerContent.slideDown(0).addClass('visible');
            $stickerDesc.text('-');
          }

      });

    }
  }


  

  // Call on page load
  toggleAccordionOnMobile(); //

  // always open Logo
  // Always-open accordion: compoundvafujk
  (function keepCompoundAccordionOpen() {
    const accordionId = '#tda-customizer-customization-option-compoundvafujk';

    function forceOpen() {
      const option = document.querySelector(accordionId);
      if (!option) return;

      const content = option.querySelector('.tda-customizer-customization-option-value-list');
      const icon = option.querySelector('.tda-customizer-customization-option-description');

      if (content) {
        content.style.display = 'block';
        content.classList.add('visible');
      }

      if (icon) {
        icon.textContent = '-';
      }
    }

    // Initial open
    forceOpen();

    // Keep it open against Angle + accordion logic
    const observer = new MutationObserver(() => {
      forceOpen();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Prevent user from closing it
    document.addEventListener(
      'click',
      function (e) {
        const accordion = e.target.closest(accordionId);
        if (!accordion) return;

        if (
          e.target.classList.contains('tda-customizer-customization-option-title') ||
          e.target.classList.contains('tda-customizer-customization-option-description')
        ) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  })();

  // part two:
  (function dependentAccordionsControl() {
    const triggerOpenId = '#tda-customizer-customization-option-value-9dobgn';
    const triggerCloseIds = [
      '#tda-customizer-customization-option-value-avfzt7',
      '#tda-customizer-customization-option-value-mj8xsn'
    ];

    const targetAccordions = [
      '#tda-customizer-customization-option-j4rojh',
      '#tda-customizer-customization-option-cre5wf',
      '#tda-customizer-customization-option-bch6an',
      '#tda-customizer-customization-option-seoz3e',
      '#tda-customizer-customization-option-frnvxq'
    ];

    function openAccordion(selector) {
      const option = document.querySelector(selector);
      if (!option) return;

      const content = option.querySelector('.tda-customizer-customization-option-value-list');
      const icon = option.querySelector('.tda-customizer-customization-option-description');

      if (content) {
        content.style.display = 'block';
        content.classList.add('visible');
      }
      if (icon) icon.textContent = '-';
    }

    function closeAccordionAndReset(selector) {
      const option = document.querySelector(selector);
      if (!option) return;

      const content = option.querySelector('.tda-customizer-customization-option-value-list');
      const icon = option.querySelector('.tda-customizer-customization-option-description');

      if (content) {
        content.classList.remove('visible');
        content.style.display = 'none';
      }
      if (icon) icon.textContent = '+';

      // Reset selected values
      option.querySelectorAll('.tda-customizer-customization-option-value-selected')
        .forEach(el => el.classList.remove('tda-customizer-customization-option-value-selected'));

      option.querySelectorAll('input[type="text"], input[type="number"]')
        .forEach(input => input.value = '');
    }

    document.addEventListener('click', function (e) {
      const openTrigger = e.target.closest(triggerOpenId);
      const closeTrigger = triggerCloseIds.find(id => e.target.closest(id));

      // OPEN targets
      if (openTrigger) {
        targetAccordions.forEach(openAccordion);
      }

      // CLOSE + RESET targets
      if (closeTrigger) {
        targetAccordions.forEach(closeAccordionAndReset);
      }
    });

  })();
  // always logo END
  
    // Function to add 'first-item' class to the first element
  function addFirstItemClass() {
      const firstItem = document.querySelector('.tda-customizer-customization-option');
      if (firstItem) {
          firstItem.classList.add('first-item');
      }
  }

  // Create an observer instance
  const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
              // Call the function to add the class
              addFirstItemClass();
          }
      }
  });

  // Start observing the target node for child elements being added or removed
  observer.observe(document.body, {
      childList: true,
      subtree: true
  });

  // Initial call in case the first item is already present
  addFirstItemClass();


  //label to placeholders
  // if ($(window).width() > 1149) {
    (function initAngleTextInputPlaceholders() {
    const containerSelector = '.tda-customizer-customization-options-container';
    const processedInputs = new WeakSet();

    function applyPlaceholders() {
      const container = document.querySelector(containerSelector);
      if (!container) return;

      const options = container.querySelectorAll('.tda-customizer-customization-option');

      options.forEach(option => {
        const titleEl = option.querySelector('.tda-customizer-customization-option-title');
        if (!titleEl) return;

        const labelText = titleEl.textContent.trim();
        if (!labelText) return;

        const inputs = option.querySelectorAll('input[type="text"]');

        inputs.forEach(input => {
          if (processedInputs.has(input)) return;

          // Do not override existing placeholder
          if (!input.placeholder) {
            input.placeholder = labelText;
          }

          processedInputs.add(input);
        });
      });
    }

    // Initial run (in case some fields already exist)
    applyPlaceholders();

    // Observe Angle 3D DOM updates
    const observer = new MutationObserver(() => {
      applyPlaceholders();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    })();
  // }
  // end of label to placeholders

}); // main closing Angle 3D product customizations 

document.addEventListener('DOMContentLoaded', () => {
  const ANGLE_3D_TAGS = ['3d virtual customization', '3d customize'];
  const angle3dByHandleCache = new Map();
  const productLabelsByHandleCache = new Map();
  const ANGLE_3D_ROOT_SELECTOR = '.related-slider, .related-slider__product, .collection-product-card, .featured-products';
  const ANGLE_3D_CARD_SELECTOR = [
    '.related-slider .card-wrapper[data-product]',
    '.related-slider__product .card-wrapper[data-product]',
    '.collection-product-card.related-slider__product .card-wrapper[data-product]',
    '.featured-products .card-wrapper[data-product]'
  ].join(', ');
  const SPF_PRODUCT_CARD_SELECTOR = '.spf-product-card';

  function getAngle3dLogoUrl() {
    if (!document.body) return null;

    return document.body.getAttribute('data-angle-3d-logo')
      || document.body.dataset.angle3dLogo
      || null;
  }

  function getAngle3dProductCards(rootElement = document) {
    if (!rootElement) return [];

    if (rootElement.matches?.(ANGLE_3D_CARD_SELECTOR)) {
      return [rootElement];
    }

    if (rootElement.matches?.(ANGLE_3D_ROOT_SELECTOR)) {
      return Array.from(rootElement.querySelectorAll('.card-wrapper[data-product]'));
    }

    return Array.from(rootElement.querySelectorAll(ANGLE_3D_CARD_SELECTOR));
  }

  function getSpfProductCards(rootElement = document) {
    if (!rootElement) return [];

    if (rootElement.matches?.(SPF_PRODUCT_CARD_SELECTOR)) {
      return [rootElement];
    }

    return Array.from(rootElement.querySelectorAll(SPF_PRODUCT_CARD_SELECTOR));
  }

  function getProductLabelsHost(cardWrapper) {
    return cardWrapper.querySelector('.card__inner') || cardWrapper.querySelector('.media');
  }

  function getSpfProductLabelsHost(spfProductCard) {
    return spfProductCard.querySelector('.spf-product-card__image-wrapper');
  }

  function getHandleFromSpfProductCard(spfProductCard) {
    if (!spfProductCard) return null;

    const linkElement = spfProductCard.querySelector('.spf-product-card__image-wrapper[href], .spf-product-card__title a[href]');
    if (!linkElement) return null;

    const href = linkElement.getAttribute('href');
    if (!href) return null;

    try {
      const url = new URL(href, window.location.origin);
      const pathMatch = url.pathname.match(/^\/products\/([^/]+)/);
      return pathMatch?.[1] || null;
    } catch (error) {
      return null;
    }
  }

  function normalizeLabelContexts(showInValue) {
    if (Array.isArray(showInValue)) {
      return showInValue
        .map((value) => String(value).trim().toLowerCase())
        .filter(Boolean);
    }

    return String(showInValue || '')
      .split(',')
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean);
  }

  async function getProductLabelsData(handle) {
    if (!handle) return null;

    if (!productLabelsByHandleCache.has(handle)) {
      const labelsPromise = fetch(`/products/${handle}`)
        .then((response) => {
          if (!response.ok) throw new Error('Product page fetch failed');
          return response.text();
        })
        .then((html) => {
          const parser = new DOMParser();
          const productDocument = parser.parseFromString(html, 'text/html');
          const labelsDataScript = productDocument.querySelector('[id^="ProductLabelsData-"]');

          if (!labelsDataScript || !labelsDataScript.textContent.trim()) {
            return null;
          }

          const parsedData = JSON.parse(labelsDataScript.textContent);
          if (!parsedData || typeof parsedData !== 'object') {
            return null;
          }

          return {
            position: String(parsedData.position || 'top').trim().toLowerCase() === 'bottom' ? 'bottom' : 'top',
            labels: Array.isArray(parsedData.labels) ? parsedData.labels : []
          };
        })
        .catch(() => null);

      productLabelsByHandleCache.set(handle, labelsPromise);
    }

    return productLabelsByHandleCache.get(handle);
  }

  function createCardProductLabelElement(label) {
    const styleKey = String(label.style_key || '').trim().toLowerCase();
    const className = styleKey ? `product-label product-label--${styleKey}` : 'product-label product-label--default';
    const url = String(label.url || '').trim();
    const text = String(label.text || '').trim();

    const element = url ? document.createElement('a') : document.createElement('span');
    element.className = className;

    if (url) {
      element.href = url;
    }

    const textElement = document.createElement('span');
    textElement.textContent = text;
    element.appendChild(textElement);

    return element;
  }

  async function syncBannerProductLabels(cardWrapper) {
    if (!cardWrapper) return;

    const badgeHost = getProductLabelsHost(cardWrapper);
    if (!badgeHost) return;

    const existingLabels = badgeHost.querySelector('.product-labels--banners');
    const handle = cardWrapper.dataset.product;
    const productLabelsData = await getProductLabelsData(handle);

    const bannerLabels = (productLabelsData?.labels || []).filter((label) => {
      const text = String(label?.text || '').trim();
      if (!text) return false;

      const contexts = normalizeLabelContexts(label.show_in);
      return contexts.includes('banners');
    });

    if (!bannerLabels.length) {
      if (existingLabels) {
        existingLabels.remove();
      }
      return;
    }

    const labelsContainer = existingLabels || document.createElement('div');
    labelsContainer.className = `product-labels product-labels--${productLabelsData.position} product-labels--banners`;
    labelsContainer.setAttribute('aria-label', 'Product labels');
    labelsContainer.innerHTML = '';

    bannerLabels.slice(0, 3).forEach((label) => {
      labelsContainer.appendChild(createCardProductLabelElement(label));
    });

    if (!existingLabels) {
      badgeHost.appendChild(labelsContainer);
    }
  }

  async function syncSpfProductLabels(spfProductCard) {
    if (!spfProductCard) return;

    const badgeHost = getSpfProductLabelsHost(spfProductCard);
    if (!badgeHost) return;

    const existingLabels = badgeHost.querySelector('.product-labels--search');
    const handle = getHandleFromSpfProductCard(spfProductCard);
    const productLabelsData = await getProductLabelsData(handle);

    const searchLabels = (productLabelsData?.labels || []).filter((label) => {
      const text = String(label?.text || '').trim();
      if (!text) return false;

      const contexts = normalizeLabelContexts(label.show_in);
      return contexts.includes('search') || contexts.includes('banners');
    });

    if (!searchLabels.length) {
      if (existingLabels) {
        existingLabels.remove();
      }
      return;
    }

    const labelsContainer = existingLabels || document.createElement('div');
    labelsContainer.className = `product-labels product-labels--${productLabelsData.position} product-labels--search`;
    labelsContainer.setAttribute('aria-label', 'Product labels');
    labelsContainer.innerHTML = '';

    searchLabels.slice(0, 3).forEach((label) => {
      labelsContainer.appendChild(createCardProductLabelElement(label));
    });

    if (!existingLabels) {
      badgeHost.appendChild(labelsContainer);
    }
  }

  async function isAngle3dProduct(handle) {
    if (!handle) return false;

    if (!angle3dByHandleCache.has(handle)) {
      const productPromise = fetch(`/products/${handle}.js`)
        .then((response) => {
          if (!response.ok) throw new Error('Product fetch failed');
          return response.json();
        })
        .then((productData) => {
          const productTags = Array.isArray(productData.tags)
            ? productData.tags
            : String(productData.tags || '').split(',');

          const normalizedTags = productTags.map((tag) => String(tag).trim().toLowerCase());
          return normalizedTags.some((tag) => ANGLE_3D_TAGS.includes(tag));
        })
        .catch(() => false);

      angle3dByHandleCache.set(handle, productPromise);
    }

    return angle3dByHandleCache.get(handle);
  }

  function syncAngle3dBadge(cardWrapper) {
    if (!cardWrapper) return;

    const logoUrl = getAngle3dLogoUrl();
    const badgeHost = getProductLabelsHost(cardWrapper);
    if (!badgeHost) return;

    const existingBadge = badgeHost.querySelector('.angle-3d-badge');

    if (!logoUrl || !cardWrapper.classList.contains('angle-3d-product')) {
      if (existingBadge) {
        existingBadge.remove();
      }
      return;
    }

    if (existingBadge) return;

    const badge = document.createElement('span');
    badge.className = 'angle-3d-badge';

    const badgeImage = document.createElement('img');
    badgeImage.src = logoUrl;
    badgeImage.alt = 'Angle 3D';
    badgeImage.loading = 'lazy';

    badge.appendChild(badgeImage);
    badgeHost.appendChild(badge);
  }

  function syncSpfAngle3dBadge(spfProductCard) {
    if (!spfProductCard) return;

    const logoUrl = getAngle3dLogoUrl();
    const badgeHost = getSpfProductLabelsHost(spfProductCard);
    if (!badgeHost) return;

    const existingBadge = badgeHost.querySelector('.angle-3d-badge');

    if (!logoUrl || !spfProductCard.classList.contains('angle-3d-product')) {
      if (existingBadge) {
        existingBadge.remove();
      }
      spfProductCard.classList.remove('3d-label');
      return;
    }

    spfProductCard.classList.add('3d-label');
    if (existingBadge) return;

    const badge = document.createElement('span');
    badge.className = 'angle-3d-badge';

    const badgeImage = document.createElement('img');
    badgeImage.src = logoUrl;
    badgeImage.alt = 'Angle 3D';
    badgeImage.loading = 'lazy';

    badge.appendChild(badgeImage);
    badgeHost.appendChild(badge);
  }

  async function markAngle3dProductsInCards(rootElement = document) {
        const cards = getAngle3dProductCards(rootElement);

        await Promise.all(
            cards.map(async (card) => {
                const handle = card.dataset.product;
                if (!handle) return;

                const [is3d] = await Promise.all([
                    isAngle3dProduct(handle),
                    syncBannerProductLabels(card)
                ]);

                card.classList.toggle('angle-3d-product', is3d);
                syncAngle3dBadge(card);
            })
        );
    }

  async function markAngle3dProductsInSpfCards(rootElement = document) {
    const cards = getSpfProductCards(rootElement);

    await Promise.all(
      cards.map(async (card) => {
        const handle = getHandleFromSpfProductCard(card);
        if (!handle) return;

        const [is3d] = await Promise.all([
          isAngle3dProduct(handle),
          syncSpfProductLabels(card)
        ]);

        card.classList.toggle('angle-3d-product', is3d);
        syncSpfAngle3dBadge(card);
      })
    );
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        if (
          node.matches?.(`${ANGLE_3D_ROOT_SELECTOR}, .card-wrapper[data-product], ${SPF_PRODUCT_CARD_SELECTOR}`)
          || node.querySelector?.(`${ANGLE_3D_CARD_SELECTOR}, ${SPF_PRODUCT_CARD_SELECTOR}`)
        ) {
          markAngle3dProductsInCards(node);
          markAngle3dProductsInSpfCards(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  let count = 0;
  const interval = setInterval(() => {
    markAngle3dProductsInCards();
    markAngle3dProductsInSpfCards();
    count += 1;
    if (count > 20) clearInterval(interval);
  }, 500);

  markAngle3dProductsInCards();
  markAngle3dProductsInSpfCards();
});


/////////////////////
////////////////////
////////////////////


document.addEventListener("DOMContentLoaded", () => {
  const processedSwatches = new WeakSet();

  function applySwatchStyle(swatch) {
    if (processedSwatches.has(swatch)) return;

    const title = swatch.getAttribute("title");
    if (!title) return;

    const colors = title.toLowerCase().split(" / ").map(c => c.trim());
    const numColors = colors.length;

    if (numColors === 1) {
      const colorHex = window.colorHexMap?.[colors[0]] || colors[0];
      swatch.style.background = colorHex;
    } else {
      const segmentSize = 360 / numColors;
      const gradientStops = colors.map((color, i) => {
        const colorHex = window.colorHexMap?.[color] || color;
        const start = i * segmentSize;
        const end = (i + 1) * segmentSize;
        return `${colorHex} ${start}deg ${end}deg`;
      }).join(", ");

      const gradient = `conic-gradient(${gradientStops})`;
      swatch.style.background = gradient;
    }

    swatch.style.borderRadius = "15px";
    swatch.style.position = "relative";

    processedSwatches.add(swatch);
   }

  function initSwatches() {
    document.querySelectorAll(".card-wrapper .color-swatch").forEach(applySwatchStyle);
  }

  // Initial run for already-loaded swatches
  initSwatches();

  // Set up MutationObserver for dynamically-loaded content
  const observer = new MutationObserver(() => {
    initSwatches(); // Re-run logic when DOM changes
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });


});
// DOMContentLoaded close
/////////////////////
/////////////////////

// Replacing 3d products image
setTimeout(() => {
  document.querySelectorAll('.spf-product-card').forEach(card => {
    const hasSwatches = card.querySelector('.spf-product__swatchs') !== null;

    // if (hasSwatches) {
    //   return;
    // }
        if (hasSwatches && !card.classList.contains('3d-label')) {
      return;
    }

    const imgWrapper = card.querySelector('.spf-product-card__image-wrapper');
    if (!imgWrapper) {
      return;
    }

    const img = imgWrapper.querySelector('img');
    const href = imgWrapper.getAttribute('href');

    if (!img || !href) {
      return;
    }

    const placeholderSrc = 'https://cdn.shopify.com/s/images/themes/product-1.png';
    const currentSrc = img.getAttribute('src');

    if (currentSrc !== placeholderSrc) {
      return;
    }


    const url = new URL(href, window.location.origin);
    const handle = url.pathname.split('/products/')[1]?.split('/')[0]?.split('?')[0];
    const variantId = url.searchParams.get('variant');

    if (!handle) {
      return;
    }


    fetch(`/products/${handle}.json`)
      .then(res => {
        if (!res.ok) {
          throw new Error(`Failed to fetch product: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {

        let imageSrc = null;

        if (variantId && data.product.variants) {
          const variant = data.product.variants.find(v => String(v.id) === String(variantId));
          if (variant && variant.featured_image && variant.featured_image.src) {
            imageSrc = variant.featured_image.src;
          } else {

          }
        }

        if (!imageSrc && data.product.images?.length > 0) {
          imageSrc = data.product.images[0];
        }

        if (imageSrc) {
          img.src = imageSrc;
        }
      })
      .catch(err => {
        console.error('Error fetching or processing product JSON:', err);
      });
  });

}, 500);
// Replacing 3d products image close
//////////////////////////////
///////////////////////////

function toggleSubmenu(caretEl) {
  const summary = caretEl.closest('summary');
  const details = summary.closest('details');
  
  if (details) {
    const isOpen = details.hasAttribute('open');
    details.toggleAttribute('open');
  }
}

// Information accordion
jQuery(document).ready(function($) {

  function openAccordion($item) {
    if (!$item.hasClass('active')) {
      $item.siblings('.accordion-item.active').removeClass('active')
           .find('.accordion-content').stop(true,true).slideUp(300)
           .end().find('.accordion-header').attr('aria-expanded', 'false');

      $item.addClass('active');
      $item.find('.accordion-content').stop(true,true).slideDown(300);
      $item.find('.accordion-header').attr('aria-expanded', 'true');
    }
  }

  // Click behavior
  $('.accordion-blocks .accordion-header').on('click', function() {
    var $item = $(this).closest('.accordion-item');

    if ($item.hasClass('active')) {
      $item.removeClass('active');
      $item.find('.accordion-content').stop(true,true).slideUp(300);
      $(this).attr('aria-expanded', 'false');
    } else {
      openAccordion($item);
    }
  });

  // Open accordion if URL has hash
  var hash = window.location.hash;
  
  if (hash) {
    var $targetItem = $(hash);
    if ($targetItem.length && $targetItem.hasClass('accordion-item')) {
      openAccordion($targetItem);

      // Scroll to the item
      $('html, body').animate({
        scrollTop: $targetItem.offset().top - 850
      }, 500);
    }
  }

});

// Render QR code in cart
// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".qr-code").forEach(function (el) {
//     const url = el.getAttribute("data-url");

//     if (url) {
//       new QRCode(el, {
//         text: url,
//         width: 200,
//         height: 200
//       });
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("qr-popup");
  if (!popup) return;

  const overlay = popup.querySelector(".qr-popup__overlay");
  const closeBtn = popup.querySelector(".qr-popup__close");
  const qrContainer = document.getElementById("qr-popup-code");

  document.addEventListener("click", function (event) {
    const button = event.target.closest(".show-qr-button");
    if (!button) return;

    const url = button.getAttribute("data-url");
    if (!url || typeof QRCode === "undefined") return;

    // Clear previous QR
    qrContainer.innerHTML = "";

    // Generate new QR
    new QRCode(qrContainer, {
      text: url,
      width: 300,
      height: 300
    });

    popup.classList.add("active");
  });

  function closePopup() {
    popup.classList.remove("active");
    qrContainer.innerHTML = "";
  }

  overlay.addEventListener("click", closePopup);
  closeBtn.addEventListener("click", closePopup);
});

// Render Globo's product metafield color filter as swatches.
// Globo renders metafield values as text, while product variant swatches are
// handled separately. Reuse the same color map as the product pages.
document.addEventListener("DOMContentLoaded", function () {
  const filterSelector =
    '[data-filter-type="product:metafield:custom:filter_colours"]';

    const filterColourOrder = [
    "black",
    "white",
    "light grey",
    "grey",
    "dark grey",
    "desert grey",
    "tundra grey",
    "light red",
    "red",
    "dark red",
    "burning red",
    "light orange",
    "orange",
    "dark orange",
    "light yellow",
    "yellow",
    "dark yellow",
    "lime",
    "light blue",
    "blue",
    "dark blue",
    "navy blue",
    "light turquoise",
    "turquoise",
    "dark turquoise",
    "light brown",
    "brown",
    "dark brown",
    "light green",
    "green",
    "dark green",
    "light pink",
    "pink",
    "dark pink",
    "violet",
    "gold",
    "silver",
  ];

  function sortFilterColours() {
    document.querySelectorAll(`${filterSelector} .gf-option-box`).forEach((list) => {
      const colourItems = Array.from(list.children).filter((item) =>
        item.querySelector("button[data-fvalue]")
      );
      const firstNonColourItem = Array.from(list.children).find(
        (item) => !item.querySelector("button[data-fvalue]")
      );

      const sortedItems = [...colourItems].sort((firstItem, secondItem) => {
          const firstName = firstItem
            .querySelector("button[data-fvalue]")
            .dataset.fvalue.trim()
            .toLowerCase();
          const secondName = secondItem
            .querySelector("button[data-fvalue]")
            .dataset.fvalue.trim()
            .toLowerCase();
          const firstOrder = filterColourOrder.indexOf(firstName);
          const secondOrder = filterColourOrder.indexOf(secondName);
          const firstPosition = firstOrder === -1 ? Infinity : firstOrder;
          const secondPosition = secondOrder === -1 ? Infinity : secondOrder;

          return firstPosition - secondPosition || firstName.localeCompare(secondName);
        });

      const isAlreadySorted = colourItems.every(
        (item, index) => item === sortedItems[index]
      );
      if (isAlreadySorted) return;

      sortedItems.forEach((item) =>
        list.insertBefore(item, firstNonColourItem || null)
      );
    });
  }

  function renderFilterColourSwatches() {
    if (!window.colorHexMap) return;

    sortFilterColours();

    document
      .querySelectorAll(`${filterSelector} button[data-fvalue]`)
      .forEach((button) => {
        if (button.dataset.filterColourSwatchRendered) return;

        const colourName = button.dataset.fvalue.trim().toLowerCase();
        const colourHex = window.colorHexMap[colourName];
        const textValue = button.querySelector(".gf-option-value");

        if (!textValue) return;

        const swatch = document.createElement("span");
        swatch.className = "gf-option-one-color gf-filter-colour-swatch";
        // An unmapped future color remains a transparent swatch instead of text.
        swatch.style.backgroundColor = colourHex || "transparent";
        swatch.setAttribute("aria-hidden", "true");

        textValue.classList.add("visually-hidden");
        button.insertBefore(swatch, textValue);
        button.dataset.filterColourSwatchRendered = "true";
      });
  }

  renderFilterColourSwatches();

  // Globo replaces filter markup after filtering, sorting, and pagination.
  new MutationObserver(renderFilterColourSwatches).observe(document.body, {
    childList: true,
    subtree: true,
  });
});
